import React from 'react'
import { useTranslation } from 'react-i18next'

import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'

import { setPageTitle } from '../utils/service'

const NotFoundView = (): JSX.Element => {
  const { t } = useTranslation()

  // update page title
  React.useEffect(() => {
    setPageTitle('')
  }, [])

  return (
    <Container component="main">
      <Typography>{t('common.notfound')}</Typography>
    </Container>
  )
}

export default NotFoundView
